jQuery(document).ready(function($) {
    if ($('body.single-actions').length == 0) return;
    actionHandler.init();
})
